export default ({request}) => ({
  masterBizDictListApi(data = {}) {
    return request({
      url: '/master/masterBizDictionary/list',
      method: 'post',
      data,
    })
  },
  masterBizDictOptionsListApi(data = {}) {
    return request({
      url: '/master/masterBizDictionary/listOption',
      method: 'post',
      data,
    })
  },
  masterBizDictOptionsDetailApi(data = {}) {
    return request({
      url: '/master/masterBizDictionary/detail',
      method: 'post',
      data,
    })
  },
  masterBizDictOptionsSaveApi(data = {}) {
    return request({
      url: '/master/masterBizDictionary/save',
      method: 'post',
      data,
    })
  },
  masterBizDictOptionsDelApi(data = {}) {
    return request({
      url: '/master/masterBizDictionary/del',
      method: 'post',
      data,
    })
  },
  masterBizDictOptionsRefreshRedisApi(data = {}) {
    return request({
      url: '/master/masterBizDictionary/refreshRedis',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
})
